<template>
  <cargo-advance-select
    ref="cargoAdvanceSelect"
    v-bind="$attrs"
    :select-type="selectType"
    :method-params="methodParams"
    :disabled="disabled"
    :filterable="filterable||allowCreate"
    :allow-create="allowCreate"
    :default-value="innerDefaultValue"
    :static-options="staticOptions"
    v-on="$listeners"
  />
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { objectIsEqual } from '@/utils/commonUtil'

export default {
  name: 'CargoRequireAdvanceSelect',
  components: { cargoAdvanceSelect },
  props: {
    selectType: { type: String, default: '' },
    methodParams: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false },
    filterable: { type: Boolean, default: false },
    allowCreate: { type: Boolean, default: false },
    defaultValue: { type: [String, Number, Boolean], default: '' },
    staticOptions: { type: Array, default: null }
  },
  data() {
    return {
      innerDefaultValue: '',
      preShowValue: '' // 上一次的显示值
    }
  },
  watch: {
    selectType() {
      this.matchDefaultValue()
    },
    methodParams(newVal, oldVal) {
      if (!objectIsEqual(newVal, oldVal)) {
        this.matchDefaultValue()
      }
    },
    disabled(newVal) {
      if (!newVal && this.innerDefaultValue !== this.defaultValue) {
        this.$refs.cargoAdvanceSelect.toNotify()
      }
    },
    allowCreate() {
      this.matchDefaultValue()
    },
    defaultValue() {
      this.matchDefaultValue()
    },
    staticOptions() {
      this.matchDefaultValue()
    }
  },
  mounted() {
    setTimeout(() => { this.matchDefaultValue() }, 100)
  },
  methods: {
    // 为空的情况下，显示上一次的值或者第一条记录
    matchDefaultValue() {
      const options = this.$refs.cargoAdvanceSelect.options
      const ownTagValue = this.$refs.cargoAdvanceSelect.ownTagValue
      if (this.allowCreate) {
        if (this.defaultValue !== '') {
          this.innerDefaultValue = this.defaultValue
          this.preShowValue = this.innerDefaultValue
          return
        }
        if (this.preShowValue !== '') {
          this.innerDefaultValue = this.preShowValue
        } else if (options.length > 0) {
          this.innerDefaultValue = options[0][ownTagValue]
          this.preShowValue = this.innerDefaultValue
        } else {
          this.innerDefaultValue = ''
        }
        if (!this.disabled) {
          this.$refs.cargoAdvanceSelect.toNotify(option)
        }
        return
      }
      if (options.length === 0) {
        this.innerDefaultValue = this.defaultValue
        this.preShowValue = ''
        return
      }
      const index = options.findIndex(p => p[ownTagValue] === this.defaultValue)
      if (index >= 0) {
        this.innerDefaultValue = this.defaultValue
        this.preShowValue = this.innerDefaultValue
        return
      }
      let option = options.findIndex(p => p[ownTagValue] === this.preShowValue)
      if (option >= 0) {
        this.innerDefaultValue = this.preShowValue
      } else {
        option = options[0]
        this.innerDefaultValue = option[ownTagValue]
        this.preShowValue = this.innerDefaultValue
      }
      if (!this.disabled) {
        this.$refs.cargoAdvanceSelect.toNotify(option)
      }
    }
  }
}
</script>
